import { render } from "./BlFormFieldWeekPeriod.vue?vue&type=template&id=08be58d7&scoped=true"
import script from "./BlFormFieldWeekPeriod.vue?vue&type=script&lang=js"
export * from "./BlFormFieldWeekPeriod.vue?vue&type=script&lang=js"

import "./BlFormFieldWeekPeriod.vue?vue&type=style&index=0&id=08be58d7&scoped=true&lang=scss"

import exportComponent from "/tmp/5e119732-5ebd-42f7-baa8-4916aa59fc29/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08be58d7"]])

export default __exports__